import { render, staticRenderFns } from "./SamsungNotes.vue?vue&type=template&id=64c21c1a&scoped=true"
import script from "./SamsungNotes.vue?vue&type=script&lang=js"
export * from "./SamsungNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c21c1a",
  null
  
)

export default component.exports